import { Component, input } from '@angular/core';
import type { CompletedShipmentPaymentDisplay } from '../../../../core/api/shipment/models/completed-shipment.model';
import type { EstimateBreakdownView } from '../../../service-step/sections/delivery-service-selection/delivery-service-matrix';
import type { SelectedDeliveryService } from '../../../service-step/sections/delivery-service-selection/delivery-service-selection.model';
import { ReviewEstimateDetails } from '../../../review-and-pay/sections/review-estimate-details/review-estimate-details';

/** Get Labels Estimated Costs section with coupon hidden and payment details shown. */
@Component({
  selector: 'app-get-labels-estimated-costs',
  imports: [ReviewEstimateDetails],
  templateUrl: './get-labels-estimated-costs.html',
  styleUrl: './get-labels-estimated-costs.scss',
})
export class GetLabelsEstimatedCosts {
  readonly selectedService = input<SelectedDeliveryService | null>(null);
  readonly breakdown = input<EstimateBreakdownView | null>(null);
  readonly paymentDisplay = input<CompletedShipmentPaymentDisplay | null>(null);
}
